import {
  TICKET_LOADING,
  GET_TICKET,
  GET_TICKET_SUCCESS,
  GET_TICKET_FAIL,
  ADD_TICKET_SUCCESS,
  ADD_TICKET_FAIL,
  DELETE_TICKET_SUCCESS,
  DELETE_TICKET_FAIL,
  UPDATE_TICKET_SUCCESS,
  UPDATE_TICKET_FAIL,
  TICKET_RESET
} from "./actionType";

const INIT_STATE = {
  tickets: [],
  error: {},
};

const Ticket = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TICKET_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TICKET:
          return {
            ...state,
            tickets: action.payload.data,
            isTicketCreated: false,
            isTicketSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TICKET_FAIL:
      switch (action.payload.actionType) {
        case GET_TICKET_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTicketCreated: false,
            isTicketSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TICKET: {
      return {
        ...state,
        isTicketCreated: false,
        loading: true,
      };
    }

    case TICKET_LOADING: {
      return {
        ...state,
        isTicketCreated: false,
        loading: true,
      };
    }

    case ADD_TICKET_SUCCESS:
      return {
        ...state,
        isTicketCreated: true,
        loading: false,
        tickets: [action.payload.data, ...state.tickets],
      };

    case ADD_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        isTicketCreated: true,
        tickets: state.tickets.filter(
          ticket => ticket.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        isTicketCreated: true,
        tickets: state.tickets.map(ticket =>
          ticket.id.toString() === action.payload.data.id.toString() ? { ...ticket, ...action.payload.data } : ticket
        ),
      };

    case UPDATE_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TICKET_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Ticket;